import React from "react";
import { FaSearch, FaProcedures } from "react-icons/fa";

export default function PatientManagementHeader({
  searchTerm,
  setSearchTerm,
  navigate,
}) {
  return (
    <div className="mb-8 flex flex-col md:flex-row items-center justify-between gap-4">
      <button
        onClick={() => navigate(`/new/registration?type=normal`)}
        className="flex items-center px-6 py-3 bg-green-100 text-green-800 rounded-lg shadow-md transition transform hover:scale-105 hover:shadow-xl focus:outline-none"
      >
        <FaProcedures className="mr-2 text-xl" />
        <span className="font-medium">Pre-Admission</span>
      </button>
      <div className="relative w-full md:w-96">
        <input
          type="text"
          placeholder="Search patients..."
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          className="w-full pl-12 pr-4 py-3 border border-gray-300 rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-green-400 bg-white text-gray-800"
        />
        <FaSearch className="absolute left-4 top-1/2 transform -translate-y-1/2 text-gray-500 text-xl" />
      </div>
    </div>
  );
}
